<template>
    <div>
        <div class="parallax">
        </div>
        <div class="container">
            <div class="card search-card p-4">
                <div class="card-body my-auto h-100">
                    <form>
                        <div class="form-row">
                            <!-- <div class="col-2">
                                <input type="range" class="custom-range" id="customRange1" v-model="price">
                            </div> -->
                            <div class="col-12">
                                <input type="text" class="form-control" placeholder="Recherche avec mots clé" v-model="description">
                            </div>
                            
                            <!-- <div class="col-3">
                                <input type="text" class="form-control" placeholder="Lieu" v-model="place">
                            </div> -->
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="container offres-result-view pb-5">
            <div class="row">
                <div class="col-12 col-sm-16 col-md-4 col-lg-4 mb-3" v-for="offer in offers" :key="offer.id">
                    <router-link :to="singleOfferLink(offer.id)">
                        <div class="card single-offre">
                            <!-- <img class="card-img-top" height="180" src="../assets/images/offres/larochelle.jpg" alt="Card image cap"> -->
                            <!-- <img class="card-img-top" height="200" :src="getOfferImage(offer)" alt="Card image cap"> -->
                            <img class="card-img-top" height="200" :src="getOfferImage(offer)" alt="Card image cap">
                            <div class="card-body">
                                <h5 class="card-title mt-3">{{offer.title}}</h5>
                                <p class="card-text offre-description"> {{offer.description}} </p>
                                <div class="price-space"> {{offer.price}} € </div>
                            </div>
                        </div>
                    </router-link>
                    <!-- {{offer.description}} -->
                </div>
            </div>

        </div>

    <Footer></Footer>

    </div>
</template>

<style lang="scss">
    .parallax {
        background-image: url("../assets/images/banniere/banniere_1.jpg");
        min-height: 245px;
        // background-attachment: fixed;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .search-card {
        top: -40px;
    }
    
    .offres-result-view .card-title {
        text-transform: uppercase;
        color: #000000;
    }
    .offres-result-view {
        a {
            color: #000000 !important;
            text-decoration: none;
        }
        color: #000000 !important;
    }
    .price-space {
        position: absolute;
        top: 192px;
        right: 0px;
        background-color: #ffc107;
        padding: 8px 8px 8px 25px;
        border-top-left-radius: 17px;
        border-bottom-left-radius: 17px;
        font-weight: 900;
        color: #000000;
    }
    .single-offre:hover {
        box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;;
    }
    .offre-description {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>

<script>
import axios from "axios";
import Footer from '@/components/Footer.vue'


export default {
    components: {
        Footer
    },
    data() {
        return {
            price: null,
            description: null,
            place: null,
            offers: null,
            image: "../assets/images/offres/larochelle.jpg"
        }
    },
    watch: {
        description() {
            this.getData(this.description);
            console.log(this.getOfferImage() )
        }
    },
    methods: {
        getOfferImage(offer) {
            return require("../assets/images/offres/"+offer.image);
        },
        singleOfferLink(id) {
            return "/single-offer/"+id;
        },
        getData() {
            // var url = 'http://localhost:8000/api/search/'+this.description+'/'+this.price+'/'+this.place;
            var url;
            if (this.description) {
                url = 'http://localhost:8000/api/search/'+this.description;
            } else {
                url = 'http://localhost:8000/api/search/'+'all';
            }
            axios
                .get(url)
                .then(response => {
                    this.offers = response.data.data;
                })
                .catch(error => console.log(error));

        },
        getImage() {

        }
    },
    mounted() {
        this.getData();
    },
}
</script>